document.addEventListener("DOMContentLoaded", () => {
  const isMobile = window.matchMedia("(max-width: 768px)");

  const mergeMenus = () => {
    if (isMobile.matches) {
      const menuItems = document.querySelectorAll(".menu-drawer__menu > li details");

      menuItems.forEach((item) => {
        const submenu = item.querySelector(".menu-drawer__submenu");
        const parent = item.closest("li");

        if (submenu && parent) {
          // Move submenu items to the main menu
          while (submenu.firstChild) {
            parent.appendChild(submenu.firstChild);
          }
          submenu.remove(); // Remove the empty submenu container
        }
      });
    }
  };

  mergeMenus();
});
